export default __webpack_public_path__ + "static/media/resume.876d965a.pdf";